<template>
    <div>
        <LazySudosuFrame v-if="isImpersonated" />
        <CountryLaunchingBanner />
        <UnsubscribeInvitationBanner />
        <HeaderUnlogged v-if="showNewUnloggedNavbar" />
        <NavbarUnlogged v-else :show-search="searchIsVisible" />
        <slot />
        <!-- Event when logged in, we want to display this footer -->
        <FooterUnlogged :always-visible="true" />

        <ClientOnly>
            <LazyHostRedirectionDialog v-if="!loggedIn" />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {FooterUnlogged, LazyHostRedirectionDialog, HeaderUnlogged, LazySudosuFrame, NavbarUnlogged} from '#components';
    import {useAuth, useNewUnloggedNavbar} from '#imports';
    import CountryLaunchingBanner from '~/components/CountryLaunchingBanner.vue';
    import UnsubscribeInvitationBanner from '~/components/UnsubscribeInvitationBanner.vue';
    import {useHeaderSearchVisibility} from '~/composables/useHeaderSearchVisibility';

    const {searchIsVisible} = useHeaderSearchVisibility();
    const showNewUnloggedNavbar = useNewUnloggedNavbar();

    const auth = useAuth();
    const {loggedIn, isImpersonated} = storeToRefs(auth);
</script>
